import React, { useState } from 'react'
import BackButton from '../../../../../components/Images/BackButton'
import { Popup } from '../../../../../components/Popup'
import { Box, Button, Text } from '../../../../../designSystem'
import {
    VoiceContainer,
    Footer,
    Header,
    TabSpan,
    VoiceTab,
    VoiceTabHolder,
    CautionCard,
    HeadingInfoIcon,
    CautionText,
} from './styles'
import VoiceList from './voiceList'
import { getObjAccordingToVoiceAndBackgroundMusic } from './musicUtils'
import CustomTooltip from '../../../../../CustomTooltip'
import BrowseList from './BrowseList'
import BackgroundMusicList from './backgroundMusicList'
import Loader from '../../../../../components/Loader'
import Exclamation from '../../../../../components/Images/Exclamation'

function VoiceSelection({
    toggleBackgroundMusicPopup,
    toggleVoiceSelectionPopup,
    showVoiceSelectionPopup,
    isSubmitting,
    genre,
    isBackgroundMusic,
    updateVoiceSelection,
    voiceSelected,
    handlePublishClick,
    bookLanguage
  }){
    const isMobile = window.screen.width < 600
    const [voiceTab,setVoiceTab] = useState('for-you')
    const [genreSelected, updateGenreSelected] = useState('')
    const objAccordingToPopup = getObjAccordingToVoiceAndBackgroundMusic(isBackgroundMusic)

    const onConfirmation = () => {
        setVoiceTab('for-you')
        updateGenreSelected('')
        toggleVoiceSelectionPopup(false)
        if (showVoiceSelectionPopup) {
            toggleBackgroundMusicPopup(true)
        }else {
            handlePublishClick()
        }
    }
    const handleBack = () => {
        setVoiceTab('for-you')
        updateGenreSelected('')
        if(isBackgroundMusic){
            toggleBackgroundMusicPopup(false)
            toggleVoiceSelectionPopup(true)
        }else{
            toggleVoiceSelectionPopup(false)
        }
    }



    return(
        <>
            <Popup 
                show
                className={isMobile ? "bottom-sheet no-margin calender-details voice-selection-popup no-padding" : "right-drawer-episode-form"} 
                close={handleBack}
                fullHeight='full-height-details'
            >
                <VoiceContainer>
                    <Header>
                        <Box p={[16,24]} display="flex" backgroundColor="#e9e9e9">
                            <BackButton onClick={handleBack}/>
                            <Box ml={8}>
                                <Text variant="heading" fontSize="20px">
                                    <span>{objAccordingToPopup?.heading}</span>
                                    <CustomTooltip
                                        content={objAccordingToPopup?.infoIconText}
                                        direction={'bottom'}
                                    >
                                        <HeadingInfoIcon />
                                    </CustomTooltip>
                                </Text>
                                <Text color="rgba(84, 181, 133, 1)" mt={4}>{objAccordingToPopup?.subHeading}</Text>
                            </Box>
                        </Box>
                        <VoiceTabHolder>
                            {!genreSelected ? ['for-you','browse'].map((tab,index) => (
                                <VoiceTab key={tab} active={voiceTab === tab} onClick={() => setVoiceTab(tab)}>
                                    <TabSpan active={voiceTab === tab}>{tab.split('-').join(' ')}</TabSpan>
                                </VoiceTab>
                            )) :  
                            <>
                                
                                <VoiceTab active>
                                    <img 
                                        onClick={() => {
                                            setVoiceTab('browse')
                                            updateGenreSelected('')
                                        }}
                                        src="https://djhonz7dexnot.cloudfront.net/1217f9b6c5354503905df7660a1900a8556f1a47.png" 
                                        width="24"
                                        height="24"
                                        style={{ marginLeft : '16px'}}
                                    />
                                    <TabSpan active>{genreSelected?.split('_')?.join(' ')}</TabSpan>
                                </VoiceTab>
                            </>}
                        </VoiceTabHolder>
                    </Header>
                    {(voiceTab === 'for-you' || genreSelected) && (!isBackgroundMusic ? <VoiceList 
                        genre={(!genreSelected ? genre : genreSelected)?.toLowerCase()}
                        musicSelected={voiceSelected?.voice_selection} 
                        onChangeSelection={(value) => updateVoiceSelection('voice_selection', value)}
                        bookLanguage={bookLanguage}
                    /> : <BackgroundMusicList 
                        genre={(genreSelected)?.toLowerCase()}
                        musicSelected={voiceSelected?.background_music} 
                        onChangeSelection={(value) => updateVoiceSelection('background_music', value)}
                        isSubmitting={isSubmitting}
                        bookLanguage={bookLanguage}
                    />)}
                    {(voiceTab === 'browse') && 
                    <BrowseList 
                        updateGenreSelected={(genre) => {
                            updateGenreSelected(genre)
                            setVoiceTab('')
                        }}
                        isBackgroundMusic={isBackgroundMusic}
                    />}
                    <Footer>
                        <Button variant="fillPrimary" onClick={onConfirmation} disabled={(isBackgroundMusic ? !voiceSelected?.background_music : !voiceSelected?.voice_selection)}>
                            {isSubmitting ? <Loader size="xs" invertColor noPadding/>  : objAccordingToPopup?.ctaText}
                        </Button>
                        <CautionCard>
                            <Exclamation fill="#6A3F06"/>
                            <CautionText>{objAccordingToPopup?.caution}</CautionText>
                        </CautionCard>
                    </Footer>
                </VoiceContainer>
            </Popup>
        </>
    )
}

export default VoiceSelection